import { useNode } from '@craftjs/core';
import { FormTimeInputComponent, FormTimeInputProps } from 'src/features/generalForms/builder/types/DateInput';
import {
  TitlePanel,
  AnswersPanel,
  LayoutPanel,
  ValidationPanel,
  LogicPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { AppTimePickerField } from 'src/features/generalForms/uikit/fields/time/timePicker';
import { TimeFieldPanel } from 'src/features/generalForms/builder/layout/panels/timeFieldPanel';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';

export const FormTimeInput: FormTimeInputComponent = (props) => {
  const {
    connectors,
    styles,
    actions: { setProp },
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;
  const validationResult = useDataKeyValidation();

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppTimePickerField
        timeEntriesIntervalInMinutes={props.timeIntervalInMinutes}
        placeholder={props.placeholder}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        isRequired={!props.isOptional}
        timeInMills={props.defaultValue}
        onTimeChanged={(newTime: number | null | undefined) => {
          setProp(
            (p: FormTimeInputProps) =>
              (p.defaultValue = newTime === null || newTime === undefined ? undefined : newTime),
            500,
          );
        }}
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

export const FormTimeInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel sections={['NoAnswerScore']} />
    <TimeFieldPanel />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormTimeInput.craft = {
  displayName: 'Time',
  rules: { canDrag: () => true },
  related: { settings: FormTimeInputSettings },
};
